<template>
    <div class="attachment-wrapper">
        <div v-if="compMessage.attachment && compMessage.attachment.length > 0" style="width: 100%">
            <div v-for="(value, propertyName) in categorisedMessageAttachment" :key="propertyName">
                <template v-if="propertyName !== 'none' && value.length > 0">
                    <el-row v-for="(attachment, index) in value" :key="attachment.ref_id + index" class="message-attachment-row">
                        <el-col :span="1" class="message-image">
                            <img v-if="value[0].ref_type === 'checklist'" height="16px" :src="getImage(value[0].ref_type)" :alt="value[0].ref_type">
                            <img v-else :src="getImage(value[0].ref_type, value[0].survey)" :alt="value[0].ref_type">
                        </el-col>
                        <el-col :span="22">
                            <span :class="['message-attachment', 'attachment-row', attachment.ref_type]">
                                <span>{{ attachment.ref_type == "excretion" ? 'Bowel Movement' : (attachment.refTitle ? attachment.refTitle : (attachment.content && attachment.content.title ? attachment.content.title : ''))}}</span>
                                <span v-if="attachment.ref_type === 'article' && showData" @click="openContentDialog(attachment)">
                                    <ArticleIcon class="article-icon"></ArticleIcon>
                                </span>
                                <span v-if="['questionnaire', 'survey'].includes(attachment.ref_type) && showData">
                                    <el-tooltip
                                        v-if="isAnsweredQuestionnaire(attachment.ref_event)"
                                        :placement="'bottom'"
                                        :content="'Answered'">
                                        <AnsweredIcon class="article-icon"></AnsweredIcon>
                                    </el-tooltip>
                                    <el-tooltip
                                        v-else
                                        :placement="'bottom'"
                                        :content="'Not Answered'">
                                        <UnansweredIcon class="article-icon"></UnansweredIcon>
                                    </el-tooltip>
                                </span>
                            </span>
                            <span v-if="attachment.survey && !isAnsweredQuestionnaire(attachment.ref_event)" @click="openLink(attachment.link)" class="survey-answer-now">Answer Now</span>
                        </el-col>
                    </el-row>
                </template>
            </div>
        </div>
        <div v-else>
            <div
                :class="['message-attachment', 'message-row', message.ref_type]"
                v-if="message.ref_type && message.ref_type !== 'message'"
                @click="openContentDialog">
                <i class="el-icon-link"></i>
                <div v-if="message.ref_type === 'questionnaire'">
                    {{ getContentKey(message.ref_type, message.ref_id, 'display_name') ||getContentKey(message.ref_type, message.ref_id, 'title') }}
                </div>
                <div v-else>
                    {{ getContentKey(message.ref_type, message.ref_id, 'title') }}
                </div>
                <span class="attachement-type">
                    {{ message.ref_type }}
                </span>
            </div>
        </div>
        <span v-if="message.ref_type === 'article' && !message.attachment" style="height: 27px" @click="openContentDialog">
            <DialogIcon class="dialog-icon"
                ></DialogIcon>
        </span>
        <el-dialog
            :append-to-body="true"
            :visible.sync="openDialog"
            top="5vh"
            class="content-modal"
            :close-on-click-modal="false"
            v-if="openDialog">
            <div class="loading-content" v-if="loadingContent">
                <LoadSpinnerIcon type="primary"></LoadSpinnerIcon>
                Loading Article Content
            </div>
            <div class="error-content" v-else-if="loadingError">
                <h3 style="color: red;">
                    There was some issue loading article. Please close and try again
                </h3>
            </div>
            <div class="article-wrapper" v-else-if="article" >
                <div class="article-title">
                    {{ article.title }}
                </div>
                <div class="article-details">
                    <span>By {{this.article.author}}</span>
                    &middot;
                    <span>{{this.article.length}} minute read</span>
                </div>
                <img :src="article.image" />
                <div class="article-content" v-html="articleContentHtml"></div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import showdown from 'showdown'
const converter = new showdown.Converter()

import LoadSpinnerIcon from '@/module/component/icon/LoadSpinner'
import Icons from './icon'
import response from '../questionnaire/analysis/response'
import questionnaire from '@/module/filter/predicate/questionnaire'

export default {
    name: 'patient-message-card-attachment',

    data() {
        return {
            openDialog: false,
            loadingContent: false,
            loadingError: false,
            typeIcon: {
                none: 'none.svg',
                appointment: 'appointment.svg',
                questionnaire: 'questionnaire.svg',
                checklist: 'checklist.svg',
                article: 'article.svg',
                exercise: 'exercise.svg',
                yoga: 'yoga.svg',
                mindfulness: 'mindfulness.svg',
                symptom: 'symptom.svg',
                vital: 'vital.svg',
                excretion: 'excretion.svg',
                category: 'category.svg',
                unhide: 'unhide.svg',
                survey: 'survey.svg'
            },
            currentArticle: null
        }
    },

    props: {
        message: {
            type: Object,
            required: true
        },
        showData: {
            type: Boolean,
            default: false,
        },
        patientId: {
            type: String
        },
    },

    methods: {
        ...mapActions('content', [
            'loadContent'
        ]),
        openContentDialog(attachment) {
            if(attachment && attachment.ref_type === 'article') {
                this.openDialog = true
                this.loadingError = false
                this.loadingContent = true
                this.loadContent({
                    type: 'article',
                    id: attachment.ref_id
                })
                .then((_) => {
                    this.currentArticle = attachment
                })
                .finally((_) => this.loadingContent = false)
                .catch((error) => this.loadingError = true)
                return
            }
            if(this.message.ref_type !== 'article')
                return
            this.openDialog = true
            this.loadingError = false
            if(this.article && !this.article.markdown) {
                this.loadingContent = true
                this.loadContent({
                    type: 'article',
                    id: this.message.ref_id
                })
                .finally((_) => this.loadingContent = false)
                .catch((error) => this.loadingError = true)
            }
        },
        getImage(refType, isSurvey) {
            return require('./image/' + this.typeIcon[refType])
        },
        isAnsweredQuestionnaire(refEvent) {
            return this.patientEvents.some((e) => {
                return e.id === refEvent && e.completed
            })
        },
        openLink(link) {
            window.open(link, '_blank')
        }
    },

    computed: {
		...mapGetters('content', [
            'getContent',
			'getContentKey'
        ]),
        ...mapGetters('provider', [
			'getPatientEvents'
        ]),
        compMessage() {
            let computedMessage, attachment = this.message.attachment

            if(this.message.attachment && Array.isArray(this.message.attachment))
                attachment = this.message.attachment.map((att) => ({
                    ...att,
                    ref_type: att.survey ? 'survey' : att.ref_type
                }))
            computedMessage = {
                ...this.message,
                attachment
            }
            return computedMessage
        },
        patientEvents() {
			return this.getPatientEvents(this.patientId)
        },
        article() {
            if(this.currentArticle)
                return this.getContent('article', this.currentArticle.ref_id)
             if(this.message.ref_type === 'article')
                return this.getContent('article', this.message.ref_id)
            return {}
        },
        /**
         * Calculates the current articles title
         */
        articleTitle() {
            if(this.message.ref_type === 'article')
                return this.getContentKey('article', this.message.ref_id, 'title')
            return ''
        },
        articleContentHtml() {
            if(this.article)
                return converter.makeHtml(this.article.markdown)
            return ''
        },
        categorisedMessageAttachment() {
            let refTypeObj = {
                none: [],
                appointment: [],
                questionnaire: [],
                checklist: [],
                article: [],
                exercise: [],
                yoga: [],
                mindfulness: [],
                symptom: [],
                vital: [],
                excretion: [],
                category: [],
                survey: []
            }
            this.compMessage.attachment.forEach((attachment)=>{
                if(refTypeObj.hasOwnProperty(attachment.ref_type)) {
                    refTypeObj[attachment.ref_type].push(attachment)
                }
            })
            return refTypeObj
        }
    },
    
    components: {
        ...Icons,
        LoadSpinnerIcon
    }
}
</script>

<style lang="scss" scoped>
@import "@/module/app/theme/color.scss";
.survey-answer-now {
    position: absolute;
    top: 14px;
    font-weight: 600;
    font-size: 11px;
    line-height: 16px;
    text-decoration-line: underline;
    color: #525252;
    cursor: pointer;
    margin-bottom: 10px;
}
.attachment-wrapper {
    display: flex;
    align-items: center;
    & > span {
        margin-top: 8px;
        height: 27px;
    }
    .article-icon {
        margin-left: 8px;
        cursor: pointer;
        vertical-align: middle;
        margin-bottom: 2px;
    }
    .dialog-icon {
        margin-left: 2px;
        cursor: pointer;
    }
}
.message-image {
    margin-top: 8px;
    margin-right: 6px;
}
.message-image img {
    height: 28px;
    width: 28px;
}
.message-row {
    display: flex;
}
.attachment-row {
    clear: both;
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
}
.message-attachment {
    border-radius: 5px;
    padding: 6px 8px 4px 8px;
    margin-right: 8px;
    margin-top: 8px;
    line-height: 1.2;
    i {
        padding: 0 2px;
    }
    .attachement-type {
        color: #95a5a6;
        padding-left: 8px;
        padding-right: 5px;
    }
    border: 1px solid #cccccc;
    background-color: #ecf0f1;
    &.questionnaire {
        border: 1px solid $questionnaire-color;
        background-color: $questionnaire-color-alt;
    }
    &.checklist {
        border: 1px solid $checklist-color;
        background-color: $checklist-color-alt;
    }
    &.article {
        cursor: pointer;
    }
    &.article, &.category {
        border: 1px solid $article-color;
        background-color: $article-color-alt;
    }
    &.exercise {
        border: 1px solid $exercise-color;
        background-color: $exercise-color-alt;
    }
    &.vital {
        border: 1px solid $vital-color;
        background-color: $vital-color-alt;
    }
     &.appointment {
        border: 1px solid $appointment-color;
        background-color: $appointment-color-alt;
    }
    &.symptom {
        border: 1px solid $symptom-color;
        background-color: $symptom-color-alt;
    }
    &.excretion {
        border: 1px solid $bowel-color;
        background-color: $bowel-color-alt;
    }
    &.mindfulness {
        border: 1px solid $mindfulness-color;
        background-color: $mindfulness-color-alt;
    }
    &.yoga {
        border: 1px solid $yoga-color;
        background-color: $yoga-color-alt;
    }
    &.category {
        border: 1px solid $bowel-color;
        background-color: $bowel-color-alt;
    }
    &.survey {
        border: none;
        background-color: #ffffff;
    }

}
</style>

<style lang="scss" >
.content-modal {
    .loading-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        svg {
            height: 30px;
            width: 30px;
            margin-bottom: 10px;
        }
    }
    .article-wrapper {
        .article-title {
            font-weight: 700;
            font-size: 28px;
            margin: 0px 0px 8px 0;
        }
        .article-details {
            color: #666666;
            margin-bottom: 15px;
        }
        & > img {
            width: 100%;
        }
        .article-content {
            word-break: break-word;
            padding: 10px;
            h1 {
                font-size: 24px;
                margin-top: 30px;
                margin-bottom: 10px;
            }
            p {
                font-size: 16px;
                line-height: 1.5;
            }
            ul > li {
                font-size: 16px;
                line-height: 1.5;
            }
        }
    }
    .el-dialog__body {
        max-height: 85vh;
        overflow: auto;
    }
    
}
</style>